export default __webpack_public_path__ + "static/media/photo-upload.8180d2c9.svg";